// Utilisateur connecté (socle §4.4) : GET /me fournit rôles, permissions effectives et affectations.
import { createContext, useContext, type ReactNode } from 'react';
import type { MeResource } from '@/api/generated/model';
import { can, type Permission } from '@/lib/permissions';

export type Me = MeResource;

const MeContext = createContext<Me | null>(null);

export function MeProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

export function useMe(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error('useMe doit être utilisé sous la garde d\'authentification.');
  return me;
}

export function useOptionalMe(): Me | null {
  return useContext(MeContext);
}

export function useCan(permission: Permission): boolean {
  return can(useOptionalMe(), permission);
}
